import { forEach } from 'lodash';
import { ModelPropertiesParser } from '../components/commons/modelPropertiesParser';

export const checkRules = (formValues, itemProperties, value) => {
    let message = null;
    let messages = [];
    let finalMsg = null;
    const rules = itemProperties ? itemProperties.validationRules : [];
    rules && rules.map((r,i) => {
        const operator = r.operator;
        const field = itemProperties.field.classProperty;
        let fieldValue = value;
        let compareValue = formValues && ModelPropertiesParser(`{{${r.property}}}`, formValues);
        if(itemProperties.field.type == 'NUMBER'){
            fieldValue = parseInt(fieldValue);
            compareValue = parseInt(compareValue)
        } else if(itemProperties.field.type == 'DECIMAL'){
            fieldValue = parseFloat(fieldValue);
            compareValue = parseFloat(compareValue)
        }
        switch (operator && operator.value.toUpperCase()) {
            case 'NOTEQUALS':
                if (fieldValue !== compareValue) {
                    message = null;
                } else
                    message = r.errorMessage;
                break;
            case 'EQUALS':
                if (fieldValue == compareValue) {
                    message = null;
                } else
                    message = r.errorMessage;
                break;
            case 'LESSTHAN':
                if (fieldValue < compareValue) {
                    message = null;
                } else
                    message = r.errorMessage;
                break;
            case 'GREATERTHAN':
                if (fieldValue > compareValue) {
                    message = null;
                } else
                    message = r.errorMessage;
                break;
            case 'LESSTHANEQUALS':
                if (fieldValue <= compareValue) {
                    message = null;
                } else
                    message = r.errorMessage;
                break;
            case 'GREATERTHANEQUALS':
                if (fieldValue >= compareValue) {
                    message = null;
                } else
                    message = r.errorMessage;
                break;
        }
        messages[i] = message
    })
    messages.forEach(m =>{
        if(m){
            finalMsg = m
        }
    })

    return finalMsg;
}

export const resolveRules = (formValues, rules, oneToManyField, targetIndex, extra) => {
    let status = true;
    let otherValue = '';
    rules && rules.map(r => {
        const operator = r.operator;
        let fieldValue = formValues && ModelPropertiesParser(`{{${r.property}}}`, formValues);
        if(oneToManyField && targetIndex > -1){
            const f = r.property.replace(oneToManyField,`${oneToManyField}[${targetIndex}]`);
            fieldValue = formValues && ModelPropertiesParser(`{{${f}}}`, formValues);
        }
        
        let staticValue = r.staticValue;
        
        switch (operator && operator.value.toUpperCase()) {
            case 'NOTEQUALS':
                if (fieldValue !== staticValue) {
                    status = true;
                    if(extra == 'labelrule'){
                        otherValue = r.label
                    }
                } else
                    if(extra == 'labelrule' && otherValue != ''){
                        status = status;
                    } else {
                        status = false;
                    }
                break;
            case 'EQUALS':
                if (fieldValue == staticValue) {
                    status = true;
                    if(extra == 'labelrule'){
                        otherValue = r.label
                    }
                } else
                    if(extra == 'labelrule' && otherValue != ''){
                        status = status;
                    } else {
                        status = false;
                    }
                break;
            case 'LESSTHAN':
                if (fieldValue < staticValue) {
                    status = true;
                    if(extra == 'labelrule'){
                        otherValue = r.label
                    }
                } else
                    if(extra == 'labelrule' && otherValue != ''){
                        status = status;
                    } else {
                        status = false;
                    }
                break;
            case 'GREATERTHAN':
                if (fieldValue > staticValue) {
                    status = true;
                    if(extra == 'labelrule'){
                        otherValue = r.label
                    }
                } else
                    if(extra == 'labelrule' && otherValue != ''){
                        status = status;
                    } else {
                        status = false;
                    }
                break;
            case 'LESSTHANEQUALS':
                if (fieldValue <= staticValue) {
                    status = true;
                    if(extra == 'labelrule'){
                        otherValue = r.label
                    }
                } else
                    if(extra == 'labelrule' && otherValue != ''){
                        status = status;
                    } else {
                        status = false;
                    }
                break;
            case 'GREATERTHANEQUALS':
                if (fieldValue >= staticValue) {
                    status = true;
                    if(extra == 'labelrule'){
                        otherValue = r.label
                    }
                } else
                    if(extra == 'labelrule' && otherValue != ''){
                        status = status;
                    } else {
                        status = false;
                    }
                break;
        }
    })

    if(extra){
        status = {
            status: status,
            otherValue: otherValue
        }
    }
    return status;
}